export const LOADING_PROGRESS = 'LOADING_PROGRESS' as const;
